import React from 'react'

export const PlagiarismIcon = ({ color }) => (
  <svg
    width="26"
    height="28"
    viewBox="0 0 26 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.53418 6.77222L21.1615 6.7757"
      stroke={color}
      strokeWidth="1.68"
      strokeLinecap="round"
    />
    <path
      d="M16.0713 9.85376L20.9899 9.85376"
      stroke={color}
      strokeWidth="1.68"
      strokeLinecap="round"
    />
    <path
      d="M15.9476 21.732L12.7607 17.6529M14.3434 14.774C14.056 17.1149 11.9253 18.7796 9.58442 18.4922C7.24353 18.2047 5.57886 16.0741 5.86629 13.7332C6.15371 11.3923 8.28439 9.72763 10.6253 10.0151C12.9662 10.3025 14.6308 12.4332 14.3434 14.774Z"
      stroke={color}
      strokeWidth="1.68"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
